// extracted by mini-css-extract-plugin
export default {"CTA":"TestimonialDetails_CTA__HGtow"};